import React from 'react';
import Footer from '../components/Footer.js';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import Card from '../components/Card.js';
import banner from '../images/about/banner.jpg';
import can from '../images/about/can.webp';
import pic1 from '../images/about/pic_1.jpg';
import pic2 from '../images/about/pic_2.jpg';
import pic4 from '../images/about/pic_4.jpg';
import { useSEO } from '../components/CustomHook';

const About = () => {
    useSEO(
        "Über Schmid Energieberatung - Ihr Experte für erneuerbare Energien",
        "Lernen Sie Can Schmid kennen - Ihr Energieberater für Wärmepumpen, Solaranlagen und nachhaltige Energielösungen. Besuchen Sie unseren Showroom in Keltern.",
        "Energieberater, Can Schmid, Showroom Keltern, Wärmepumpe Beratung, Solaranlage Beratung, erneuerbare Energien",
        "/images/about/showroom.webp"
    );

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={banner}
                title="Nachhaltige Energie für Ihr Zuhause – mit Expertise und Leidenschaft"
                subtitle="Besuchen Sie unseren Showroom in Keltern"
                description="Erleben Sie Energietechnologie hautnah. In unserem Showroom in Keltern laden wir Sie ein, die Welt der nachhaltigen Energielösungen persönlich zu entdecken. Hier haben Sie die Möglichkeit, unsere Produkte wie Photovoltaikanlagen, Wärmepumpen und Heizstäbe hautnah zu erleben und sich einen Eindruck von deren Qualität und Funktionalität zu verschaffen."
                buttonLabel="Beratung vereinbaren"
                buttonDestination="/kontakt"
            />
            <Card
                title="Über mich und mein Unternehmen"
                description="Mein Name ist Can Schmid, und ich habe es mir zur Aufgabe gemacht, Eigenheimbesitzern dabei zu helfen, die Energiewende auch bei sich zu Hause voranzutreiben. Mit einer fundierten Ausbildung als Energieberater und viel Praxiserfahrung arbeite ich eng mit einem Netzwerk aus qualifizierten Handwerksprofis zusammen, darunter erfahrene Maler, Sanitär und Heizungstechniker, Dachdecker und Elektriker aus der Region. Dabei lege ich großen Wert auf die Zusammenarbeit mit einem regionalen Großhändler, um Ihnen nicht nur hochwertige Produkte, sondern auch faire Preise anbieten zu können."
                imagePlacement="left"
                imgSrc={can}
            />

            {/* New Contact Information Section */}
            <section className="py-16 px-4 sm:px-8 lg:px-12 bg-gray-50">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
                        Beratung vor Ort – immer für Sie da
                    </h2>
                    <p className="text-xl text-gray-700 mb-10 max-w-3xl mx-auto leading-relaxed">
                        Unser Showroom ist nicht nur ein Ort zum Anschauen, sondern auch zum
                        Anfassen und Verstehen. Ein kompetenter Ansprechpartner ist immer vor
                        Ort, um all Ihre Fragen zu beantworten und Sie individuell zu beraten.
                        Schauen Sie vorbei und lassen Sie sich inspirieren – wir freuen uns auf
                        Ihren Besuch!
                    </p>
                    <div className="mt-12 space-y-4">
                        <p className="text-2xl text-gray-800 font-medium">Ettlinger Straße 43</p>
                        <p className="text-2xl text-gray-800 font-medium">75210 Keltern</p>
                        <p className="text-2xl text-gray-800 font-medium">
                            <a href="mailto:c.schmid@schmidenergieberatung.de" className="hover:text-primary transition-colors duration-200">
                                c.schmid@schmidenergieberatung.de
                            </a>
                        </p>
                        <p className="text-2xl text-gray-800 font-medium">
                            <a href="tel:+49723627933055" className="hover:text-primary transition-colors duration-200">
                                07236/27933055
                            </a>
                        </p>
                        <p className="text-2xl text-gray-800 font-medium">
                            <a href="tel:+491788134334" className="hover:text-primary transition-colors duration-200">
                                0178/8134334
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            {/* Asymmetric 2x2 Image Grid Section */}
            <section className="py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {/* Top-left tile - smaller */}
                        <div className="rounded-lg h-96 overflow-hidden">
                            <img
                                src={pic1}
                                alt="Showroom 1"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Top-right tile - spans 2 columns on desktop, full width on mobile */}
                        <div className="rounded-lg h-96 overflow-hidden md:col-span-2">
                            <img
                                src={pic4}
                                alt="Showroom 2"
                                className="w-full h-full object-cover object-[50%_35%]"
                            />
                        </div>

                        {/* Bottom-left tile - spans 2 columns on desktop, full width on mobile */}
                        <div className="rounded-lg h-96 overflow-hidden md:col-span-2">
                            <img
                                src={pic2}
                                alt="Showroom 3"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        {/* Bottom-right tile - smaller */}
                        <div className="rounded-lg h-96 overflow-hidden">
                            <img
                                src={pic2}
                                alt="Showroom 4"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Google Maps Section */}
            <section className="py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="rounded-lg overflow-hidden shadow-lg">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2594.016810865684!2d8.57253931560344!3d48.91321997930295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4797111d45b4b4d7%3A0x4d4f4d4d4d4d4d4d!2sEttlinger%20Stra%C3%9Fe%2043%2C%2075210%20Keltern%2C%20Germany!5e0!3m2!1sen!2sus!5m2!1sen!2sus"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Schmid Energieberatung Location"
                        ></iframe>
                    </div>
                </div>
            </section>

            {/* Visit Us Section with Button */}
            <section className="py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
                        Besuchen Sie uns!
                    </h2>
                    <a
                        href="/kontakt"
                        className="bg-primary text-white rounded-lg font-semibold text-sm px-4 py-2 lg:px-6 lg:py-3 transition-all duration-200 hover:scale-105 inline-block"
                    >
                        Termin vereinbaren
                    </a>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default About;

